import { render, staticRenderFns } from "./ReminderPublic.vue?vue&type=template&id=651d0985&scoped=true&"
import script from "./ReminderPublic.vue?vue&type=script&lang=js&"
export * from "./ReminderPublic.vue?vue&type=script&lang=js&"
import style0 from "./ReminderPublic.vue?vue&type=style&index=0&id=651d0985&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d0985",
  null
  
)

export default component.exports